import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const documenso = defineConnector({
  identifier: "documenso",
  name: "Documenso",
  tagLine: "Open source document signing",
  logo,
  protocol: "http",
  tags: ["documents"],
  defaultUrlPattern: () => "https://app\\.documenso\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Documenso](https://app.documenso.com/), go to **Settings › API Tokens** and create a new token. See the [API docs](https://docs.documenso.com/developers/public-api/authentication) for details.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          placeholder: "api_...",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.documenso.com/api/v2/documents",
  },
});
